import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { injectIntl } from 'react-intl';

import WishListIcon from '../../WishListIcon/WishListIcon';
import SocialShareModal from '../SocialShareModal';

import messages from '../../../locale/jsonMessages';
import { getDynamicTitle } from '../../../helpers/GetDynamicItemName/getDynamicName';
import { openSocialShareModal } from '../../../actions/modalActions';

//Images
import shareIcon from '/public/siteImages/shareIcon.svg';
import starImage from '/public/SiteIcons/star.svg';

import cs from '../../../components/commonStyle.css';
import c from '../../../components/ViewListing/common.css';
import s from './ListTitle.css';

class ListTitle extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    formatMessage: PropTypes.any,
    isHost: PropTypes.bool.isRequired,
    isHost: false,
    contactHostOpen: PropTypes.any.isRequired,
  };

  handleClick = async () => {
    const { openSocialShareModal } = this.props;
    var root = document.getElementsByTagName('html')[0];
    root.classList.add('scrollHidden');
    await openSocialShareModal()
  }

  handleRelease = () => {
    var root = document.getElementsByTagName('html')[0];
    root.classList.remove('scrollHidden');
  }

  render() {
    const { data, loading, openSocialShareModal, starRatingValue, locale, dynamicTitle } = this.props;
    const { formatMessage } = this.props.intl;
    let isListOwner, wishListStatus, dynamicListTitle;
    isListOwner = data.isListOwner;
    wishListStatus = data.wishListStatus;
    dynamicListTitle = getDynamicTitle({ data: dynamicTitle, locale, id: data?.id });

    return (
      <div className={s.padding}>
        <h1 className={cx(cs.commonTitleText, cs.paddingBottom1, cs.fontWeightBold)}>
          {data.title ? (dynamicListTitle || data.title) : data?.settingsData && data?.settingsData?.length > 0 && data?.settingsData[0]?.listsettings?.itemName + ' ' + formatMessage(messages.in) + ' ' + data.city}
        </h1>
        <div className={cx(s.displayFlex, s.alignItemEnd, s.disGridTitle)}>
          <div>
            <SocialShareModal handleRelease={this.handleRelease} listId={data.id} title={data.title} city={data.city} state={data.state} country={data.country} />
            <p className={cx(cs.commonContentText, cs.fontWeightNormal, c.reviewStarSection, s.mobilePadding)}>
              {starRatingValue > 0 && <span className={c.reviewCountFlex}>
                <img src={starImage} className={cx(c.starImageMargin, 'viewlistStarImage')} />
                <span>{' '}{starRatingValue}</span>
              </span>}{' '}
              <span className={cx(s.lineHeight, 'viewlistDotSectionRTL', { [c.dotSection]: starRatingValue > 0 })}>{data.city}, {data.state}, {data.country}</span>
            </p>
          </div>
          <div className={cx(s.displayFlex, s.justifyTab)}>
            {
              !isListOwner && !loading && <><WishListIcon type="button" listId={data.id} key={data.id} isChecked={wishListStatus} isViewListing={true} />
              </>
            }
            {
              <div className={cx(s.displayFlex, s.alignItemCenter, cs.curserPointer)} onClick={() => this.handleClick()}>
                <img src={shareIcon} className={cx(cs.viewListIcon, 'commonIconSpace')} />
                <h5 className={cx(cs.commonContentText, cs.fontWeightNormal)}>{formatMessage(messages.share)}</h5>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  locale: state?.intl?.locale,
  dynamicTitle: state?.dynamicListTitles?.data?.dynamicListTitle
});

const mapDispatch = {
  openSocialShareModal
};

export default injectIntl(withStyles(cs, c, s)(connect(mapState, mapDispatch)(ListTitle)));